import { BoxProps, Icon, Stack, Text } from '@chakra-ui/react';
import { ExclamationIcon } from '@heroicons/react/outline';
import { useTranslations } from 'use-intl';

type Props = BoxProps;

/**
 * NotAllowedCard.
 * Full width stack for error on data fetching.
 *
 * @param {Props}
 * @returns {JSX.Element}
 */
export function NotAllowedCard({ ...props }: Props): JSX.Element {
  const i18nGeneral = useTranslations('General');

  return (
    <Stack layerStyle="emptyState" {...props}>
      <Icon as={ExclamationIcon} boxSize="40px" color="gray.400" />
      <Stack alignItems="center" spacing="0">
        <Text>{i18nGeneral('PageNotAllowed')}</Text>
      </Stack>
    </Stack>
  );
}

export type NotAllowedCardProps = Props;
